import { RemoveRedEyeOutlined, RemoveRedEyeSharp, VisibilityOff } from "@mui/icons-material";
import { IconButton, OutlinedTextFieldProps, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTheme } from '@mui/material/styles';
import TextFieldMakeAnimationStartHandler from "./TextFieldMakeAnimationStartHandler";

export interface PasswordboxProps extends Omit<OutlinedTextFieldProps, 'varaint'> {
    password: string;
    onEnter?: () => void;
    onPasswordChange: (event: any) => void;
    onPasswordAutofilled?: () => void;
    label?: string;
}

export default function Passwordbox(props: PasswordboxProps) {

    const { password, onPasswordChange, onEnter, onPasswordAutofilled, label } = props;
    const theme = useTheme();
    const handleKeyPress = (e: any) => {
        // console.log(e);
        if (e.key === 'Enter') {
            if (onEnter)
                onEnter();
        }
    }
    const onPassChange = (event: any) => {
        // console.log(event.currentTarget.value);
        onPasswordChange(event!.currentTarget!.value);
    };

    // let [passwordState, setPasswordState] = useState("");
    let [passwordMode, setPasswordMode] = useState("password");
    const [isPasswordAutofilled, setIsPasswordAutofilled] = useState(false);
    useEffect(() => {
        if (isPasswordAutofilled && onPasswordAutofilled) {
            onPasswordAutofilled();
        }
    }, [isPasswordAutofilled, onPasswordAutofilled]);
    return (
        <div>
            <TextField
                {...props}
                
                className="text-field"
                type={passwordMode}
                variant="outlined"
                value={password}
                onChange={onPassChange}
                id="outlined-password-input"
                label={label ?? 'Heslo'}
                onKeyDown={handleKeyPress}
                slotProps={{
                    htmlInput: {
                        onAnimationStart: TextFieldMakeAnimationStartHandler(setIsPasswordAutofilled),
                    },
                    inputLabel: {
                        shrink: password !== "" || isPasswordAutofilled
                    },
                    input: {

                        endAdornment:
                            <IconButton tabIndex={-1} onClick={() => {
                                if (passwordMode === 'password')
                                    setPasswordMode("text");
                                else setPasswordMode("password");
                            }}> {
                                    passwordMode === 'password' ?
                                        <RemoveRedEyeOutlined sx={{ opacity: '0.4' }} /> : <VisibilityOff />
                                }</IconButton>

                    }
                }}

            />
        </div>
    );
}